"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDuplicatesWithComparison = void 0;
function removeDuplicatesWithComparison(arr, compare) {
    return arr.filter(function (item1, pos) { return arr.findIndex(function (item2) { return compare(item1, item2); }) === pos; });
}
exports.removeDuplicatesWithComparison = removeDuplicatesWithComparison;
